import React, { useMemo } from 'react';
import InputComponent from '@ui/components/Input/Input.component';
import ModalComponent from '@ui/components/Modal/Modal.component';
import ButtonComponent from '@ui/components/Button/Button.component';
import ButtonBarComponent from '@ui/components/Button-bar/Button-bar.component';
import ModalFormComponent from '@ui/components/Modal-form/Modal-form.component';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    lang,
    loading,
    email,
    emailError,
    notExistError,
    serverError,
    onEmailChange,
    onSendClick,
    onInputClick,
    onKeyDown,
    onBtnKeyDown,
    onClose,
}: IProps) => {
    const alertMessage = useMemo(() => {
        if (notExistError) return 'notExistError';
        else if (serverError) return 'serverError';
        else return '';
    }, [notExistError, serverError]);

    return (
        <ModalComponent
            className="password-recovery"
            title="passwordRecovery"
            text="inputEmailForRecovery"
            alertText={alertMessage}
            lang={lang}
            loading={loading}
            onBtnKeyDown={onBtnKeyDown}
            onClose={onClose}
        >
            <ModalFormComponent>
                <InputComponent
                    label="email"
                    name="email"
                    type="email"
                    helperText="emailAlertMessage"
                    errorMessage="emailAlertMessage"
                    lang={lang}
                    value={email}
                    error={emailError}
                    onChange={onEmailChange}
                    onClick={onInputClick}
                    onFocus={onInputClick}
                    onKeyDown={onKeyDown}
                />
            </ModalFormComponent>
            <ButtonBarComponent>
                <ButtonComponent
                    label="recover"
                    lang={lang}
                    onClick={onSendClick}
                    onKeyDown={onBtnKeyDown}
                />
            </ButtonBarComponent>
        </ModalComponent>
    );
};

const PasswordRecoveryComponent = React.memo(Component);

export default PasswordRecoveryComponent;
